import { apiClient } from "../../../api/client";
import * as ActionType from "./attribute.type";
import { setToast } from "../../../util/toast";

// get attributes
export const getAttribute = ({ subCategoryId, fieldType }) => async (dispatch) => {
  const res = await apiClient.get(
    `attributes/listAllAttributes?subCategoryId=${subCategoryId}&fieldType=${fieldType}`
  );
  if (res.ok) {
    dispatch({ type: ActionType.GET_ATTRIBUTE, payload: res.data?.attributes });
  } else {
    console.log(res.message);
  }
};

// get attribute type wise
export const getAttributeType = (type) => async (dispatch) => {
  const res = await apiClient.get(`attributes/typeWise?type=${type}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_TYPE_ATTRIBUTE,
      payload: res.data?.attributes,
    });
  } else {
    console.log(res.message);
  }
};

// create attributes
export const createAttribute = (data) => async (dispatch) => {
  const res = await apiClient.post("attributes/insertAttributes", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.CREATE_ATTRIBUTE,
      payload: res.data.attributes,
    });
    setToast("success", "attributes created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// edit attributes
export const updateAttribute = (data) => async (dispatch) => {
  const res = await apiClient.patch("attributes/updateAttributes", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_ATTRIBUTE,
      payload: res.data.existingAttr,
    });
    setToast("success", "attributes update successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// delete attributes
export const deleteAttribute = (data) => async (dispatch) => {
  const res = await apiClient.delete(
    `attributes/destroyAttribute?attributeId=${data}`
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DELETE_ATTRIBUTE,
      payload: data,
    });
    setToast("success", "attributes Delete successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getAllSubcategory = () => async (dispatch) => {
  const res = await apiClient.get("subCategory/fetchActiveSubCategories");
  if (res.ok) {
    dispatch({ type: ActionType.GET_SUBCATEGORY, payload: res.data?.subCategories });
  } else {
    console.log(res.message);
  }
};
